module.exports = __webpack_public_path__ + "static/accenture-ee14f2d7ec6d4e9245400f626b38c7b8.svg";